import type { BadgeTone } from "@plataforma/design-system";
import type { AppointmentStatus, InvoiceStatus } from "@plataforma/shared";

export const appointmentStatusLabel: Record<AppointmentStatus, string> = { scheduled: "Agendada", confirmed: "Confirmada", completed: "Realizada", cancelled: "Cancelada", no_show: "Não compareceu" };
export const appointmentStatusTone: Record<AppointmentStatus, BadgeTone> = { scheduled: "accent", confirmed: "success", completed: "neutral", cancelled: "danger", no_show: "danger" };

export const invoiceStatusLabel: Record<InvoiceStatus, string> = { pending: "Pendente", issued: "Emitida", cancelled: "Cancelada" };
export const invoiceStatusTone: Record<InvoiceStatus, BadgeTone> = { pending: "warning", issued: "success", cancelled: "danger" };

/** 0 = segunda ... 6 = domingo, como no contrato da API. */
export const weekdayLabels = ["Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado", "Domingo"];
